<template>
  <div class="">
    <el-tabs v-model="activeENV" class="ert_tabs" @tab-click="changeENV">
      <el-tab-pane label="UAT环境" name="UAT" />
      <el-tab-pane label="PROD环境" name="PROD" />
    </el-tabs>
    <el-row :gutter="20">
      <el-col :span="6">
        <div>
          <el-input
            v-model="key"
            placeholder="搜索项目信息"
            class="input-with-select"
            size="small"
            suffix-icon="el-icon-search"
          />
        </div>
      </el-col>
      <el-col :span="18" class="btn">
        <div v-if="activeENV === 'UAT'">
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            size="small"
            @click="createOrEdit"
            :disabled="!is_show"
            >创建项目</el-button
          >
        </div>
      </el-col>
    </el-row>
    <div class="container-table">
      <el-table
        ref="filterTable"
        v-loading="loading"
        stripe
        size="mini"
        :data="tableData"
        style="width: 100%"
        @filter-change="filterChange"
        border
        :cell-style="cellStyle"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column prop="code" label="项目编码" width="110" />
        <el-table-column prop="short_name" label="项目简称">
          <template slot-scope="scope">
            <span
              v-if="
                scope.row['short_name'].includes('盂唇损伤') &&
                scope.row['clinical_trials_code'] === 'CEA2016-123SM'
              "
              v-html="
                scope.row.short_name.replace(
                  '盂唇损伤',
                  `<span class='row_key_bg'>盂唇损伤</span>`
                )
              "
            ></span>

            <span
              v-else-if="
                scope.row.short_name.includes('半月板') &&
                scope.row['clinical_trials_code'] === 'CEA2020-26SM'
              "
              v-html="
                scope.row.short_name.replace(
                  /半月板/g,
                  `<span class='row_key'>半月板</span>`
                )
              "
            ></span>
            <div style="font-size: 12px" v-else>{{ scope.row.short_name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="sponsor_name" label="申办方" />
        <el-table-column
          prop="clinical_trials_code"
          label="临床试验方案号"
          width="131"
        />
        <el-table-column
          prop="status"
          label="项目状态"
          column-key="status"
          width="120"
          :filters="list"
          filter-placement="bottom-end"
        />
        <el-table-column
          width="125"
          prop="first_join_group_time"
          label="首例入组时间"
        />
        <el-table-column width="120" label="操作">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :disabled="scope.row.is_synchro_edc"
              :underline="false"
              class="edit"
              @click="editClick(scope.row)"
              >编辑</el-link
            >
            <el-link
              type="primary"
              :underline="false"
              style="font-size: 12px"
              @click="goNext(scope.row)"
              >进入项目</el-link
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pages">
      <el-pagination
        samll
        background
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!--创建项目-->
    <el-dialog
      :visible.sync="centerDialogVisible"
      :close-on-click-modal="false"
      width="60%"
      center
      @close="resetForm('ruleForm')"
    >
      <div slot="title" class="title">{{ text }}</div>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        class="proInfo"
        label-width="100px"
      >
        <el-form-item label="项目名称：" prop="name" size="mini">
          <el-input v-model="ruleForm.name" />
        </el-form-item>
        <el-form-item label="项目简称：" prop="short_name" size="mini">
          <el-input v-model="ruleForm.short_name" />
        </el-form-item>
        <el-form-item label="申办单位：" prop="sponsor" size="mini">
          <el-input v-model="ruleForm.sponsor" />
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目编码：" size="mini">
              <el-input
                v-model="ruleForm.code"
                disabled
                placeholder="系统自动生成，无需填写"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="临床试验方案号："
              label-width="145px"
              size="mini"
              prop="clinical_trials_code"
            >
              <el-input v-model="ruleForm.clinical_trials_code" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开始时间：" size="mini">
              <el-date-picker
                v-model="ruleForm.start_time"
                style="width: 100%"
                size="mini"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="有效时间(个月)："
              size="mini"
              label-width="134px"
            >
              <el-input v-model="ruleForm.effective_month" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="研究领域：" size="mini">
              <el-select
                v-model="ruleForm.research_field"
                placeholder="请选择活动区域"
              >
                <el-option
                  v-for="(item, index) in options"
                  :key="index"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="样本量：" size="mini">
              <el-input
                v-model="ruleForm.sample_size"
                type="number"
                @mousewheel.native.prevent
              />
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          size="mini"
          type="primary"
          @click="addOrEdit('ruleForm')"
          >确 定</el-button
        >
        <el-button size="mini" @click="resetForm('ruleForm')">取 消</el-button>
      </span>
    </el-dialog>
    <!--修改密码-->
    <el-dialog
      :visible.sync="passDialogVisible"
      width="45%"
      center
      @close="firstLoginClose"
    >
      <div
        slot="title"
        style="
          border: 1px solid #fff;
          letter-spacing: 0.2px;
          font-weight: 500;
          padding-top: 20px;
        "
      >
        <h3>欢迎您首次登陆医兰德系统</h3>
        <h3>为了您的账户安全，请您修改初始登录密码</h3>
      </div>
      <div
        style="
          padding: 20px 30px;
          background-color: #f0f5ff;
          border-radius: 2px;
          margin: 0 20px;
        "
      >
        <el-form
          ref="ruleFormPass"
          :model="ruleFormPass"
          status-icon
          :rules="rulesPass"
          :hide-required-asterisk="true"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="旧密码" prop="oldPass">
            <el-input
              v-model="ruleFormPass.oldPass"
              size="mini"
              type="password"
              autocomplete="off"
              placeholder="请输入旧密码"
            />
          </el-form-item>
          <el-form-item label="新密码" prop="pass">
            <el-input
              v-model="ruleFormPass.pass"
              size="mini"
              type="password"
              autocomplete="off"
              placeholder="请输入新密码"
            />
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input
              v-model="ruleFormPass.checkPass"
              size="mini"
              type="password"
              autocomplete="off"
              placeholder="请再次输入新密码"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="mini"
          @click="submitForm('ruleFormPass')"
          >确 定</el-button
        >
        <el-button size="mini" @click="passCancel('ruleFormPass')"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { updatePass } from "@/api/user";
import {
  getPro,
  addPro,
  detailPro,
  ResearchList,
  editPro,
} from "@/api/platform";
import {
  setProjectId,
  setProName,
  setProNo,
  removeProjectId,
  setRandom,
  setBlind,
  setSection,
  setProInfo,
} from "@/utils/auth";
export default {
  name: "Platform",
  data() {
    var validateOldPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入旧密码"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleFormPass.checkPass !== "") {
          this.$refs.ruleFormPass.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleFormPass.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      cellStyle: {
        textAlign: "center",
      },
      text: "创建项目",
      timer: "",
      key: "",
      options: [], // 研究列表
      centerDialogVisible: false,
      passDialogVisible: false, // 修改密码
      currentPage: 1, // 当前页
      pageSize: 10, // 每页显示条数
      total: null, // 总条数
      tableData: [],
      proId: "",
      expireTimeOption: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 禁用以前的日期，今天不禁用
          // return date.getTime() <= Date.now();    //禁用今天以及以前的日期
        },
      },
      rules: {
        name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        short_name: [
          { required: true, message: "请输入项目简称", trigger: "blur" },
          {
            min: 0,
            max: 30,
            message: "长度在 0 到 30 个字符",
            trigger: "blur",
          },
        ],
        sponsor: { required: true, message: "请输入申办单位", trigger: "blur" },
        code: [{ required: true, message: "请输入项目编号", trigger: "blur" }],
        planNum: [
          { required: true, message: "请输入项目编号", trigger: "blur" },
        ],
        clinical_trials_code: [
          { required: true, message: "请输入方案编号", trigger: "blur" },
        ],
      },
      ruleForm: {
        name: "",
        short_name: "",
        sponsor: "",
        code: "",
        clinical_trials_code: "",
        start_time: "",
        effective_month: "",
        research_field: "",
        sample_size: "",
      },
      ruleFormPass: {
        oldPass: "",
        pass: "",
        checkPass: "",
      },
      rulesPass: {
        oldPass: [{ validator: validateOldPass, trigger: "blur" }],
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
      loading: false,
      list: [
        { text: "项目创建中", value: "项目创建中" },
        { text: "项目进行中", value: "项目进行中" },
        { text: "项目已锁定", value: "项目已锁定" },
      ],
      status: null,
      activeENV: sessionStorage.getItem("iwrs_environment") || "UAT", //环境
    };
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    is_show() {
      if (this.$store.getters.isAdmin === "false") {
        return false;
      } else {
        return this.$store.getters.isAdmin;
      }
    },
  },
  created() {
    this.passDialogVisible = this.$store.getters.firstLogin;
    removeProjectId();
    this.getPro();
    this.getStudyList();
    console.log(this.$store.getters.isAdmin);
  },
  methods: {
    //防抖
    debounce(fn, time) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(fn, time);
    },
    changeENV(item) {
      sessionStorage.setItem("iwrs_environment", item.name);
      this.currentPage = 1;
      this.getPro();
      location.reload();
    },
    filterChange(filter) {
      this.status = filter.status;
      this.currentPage = 1;
      this.getPro();
    },
    getPro() {
      const params = {
        key: this.key,
        page: this.currentPage - 1,
        page_size: this.pageSize,
        status: this.status,
      };
      // console.info(params);
      const res = this.$qs.stringify(params, { arrayFormat: "repeat" });
      getPro(res)
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.tableData = res.data;
            } else {
              this.tableData = [];
            }
            this.total = res.total;
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    getStudyList() {
      this.loading = true;
      ResearchList()
        .then((res) => {
          if (res && res.code === 0) {
            this.loading = false;
            if (res.data && res.data.length > 0) {
              this.options = res.data;
            } else {
              this.options = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    firstLoginClose() {
      // chucdxsnackdsncd
      this.$store.dispatch("user/setFirstLogin", false);
    },
    // 修改表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // 改表头颜色
      if (rowIndex === 0) {
        return "background-color: #D6E4FF;color: #595959;text-align:center;";
      }
    },
    formatter(row, column) {
      return row.address;
    },
    // 修改密码
    submitForm(passName) {
      this.$refs[passName].validate((valid) => {
        if (valid) {
          const params = {
            old_pwd: this.ruleFormPass.oldPass,
            new_pwd: this.ruleFormPass.checkPass,
          };
          updatePass(params)
            .then((res) => {
              if (res && res.code === 0) {
                this.passDialogVisible = false;
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.passCancel("passName");
              } else {
                this.$message(res.msg);
              }
            })
            .catch((res) => {
              console.log(res);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    passCancel(passName) {
      this.passDialogVisible = false;
      this.$refs[passName].resetFields();
    },
    // 创建项目
    createOrEdit() {
      this.text = "创建项目";
      this.centerDialogVisible = true;
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getPro();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPro();
    },
    // 创建项目
    addOrEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            name: this.ruleForm.name,
            short_name: this.ruleForm.short_name,
            sponsor: this.ruleForm.sponsor,
            clinical_trials_code: this.ruleForm.clinical_trials_code,
            start_time: this.ruleForm.start_time,
            effective_month: this.ruleForm.effective_month,
            research_field: this.ruleForm.research_field,
            sample_size: this.ruleForm.sample_size,
          };
          if (!this.proId) {
            this.addPro(params);
          } else {
            params.id = this.proId;
            this.editPro(params);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addPro(params) {
      addPro(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.centerDialogVisible = false;
            this.resetForm("ruleForm");
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    editPro(params) {
      editPro(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.proId = "";
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.centerDialogVisible = false;
            this.resetForm("ruleForm");
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    editClick(row) {
      this.centerDialogVisible = true;
      this.text = "编辑项目";
      detailPro({ id: row.id })
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data) {
              this.proId = res.data.id;
              this.ruleForm.name = res.data.name;
              this.ruleForm.short_name = res.data.short_name;
              this.ruleForm.code = res.data.code;
              this.ruleForm.sponsor = res.data.sponsor_name;
              this.ruleForm.clinical_trials_code =
                res.data.clinical_trials_code;
              this.ruleForm.start_time = res.data.start_time;
              this.ruleForm.effective_month = res.data.effective_month;
              this.ruleForm.research_field = res.data.research_field;
              this.ruleForm.sample_size = res.data.sample_size;
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    resetForm(formName) {
      this.getPro();
      this.proId = "";
      this.ruleForm.code = "";
      this.ruleForm.clinical_trials_code = "";
      this.ruleForm.start_time = "";
      this.ruleForm.effective_month = "";
      this.ruleForm.research_field = "";
      this.ruleForm.sample_size = "";
      this.centerDialogVisible = false;
      this.$refs[formName].resetFields();
    },
    goNext(row) {
      this.$store.dispatch("user/getRole", row.id);
      // console.log(row)
      setProInfo(row);
      //
      setProjectId(row.id);
      setProName(row.short_name);
      setProNo(row.code);
      setRandom(row.random_type); // 动静态随机
      setBlind(row.blind_type); // 盲态设置
      setSection(row.section_type); // 竞争、分配区段
      this.$router.push({
        path: "/homepage/index",
      });
      console.log(setProName);
    },
  },
  watch: {
    key(value) {
      this.debounce(this.getPro, 500);
    },
  },
};
</script>

<style scoped>
.btn {
  text-align: right;
}
.container-table {
  margin-top: 20px;
}
.title {
  padding: 15px 0;
  background-color: #d6e4ff;
  color: #595959;
  font-weight: 500;
  font-size: 16px;
}
.proInfo {
  background-color: #f0f5ff;
  padding: 20px 30px;
}

.row_key_bg {
  background: sandybrown;
  font-weight: 800;
  font-size: 14px;
}

.colm-left {
  line-height: 26px;
}
.pages {
  margin-top: 30px;
  text-align: right;
}
.edit {
  font-size: 12px;
  margin-right: 10px;
}
</style>
<style>
.el-dialog__header {
  padding: 0px;
}
.container-table {
  border: 1px solid #e5eeff;
}
.el-tooltip__popper.is-light {
  border: none;
  background: #ffffff;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    -1px -1px 12px 0px rgba(0, 0, 0, 0.12);
}
.popper__arrow {
  border: none !important;
}
.row_key_bg {
  background: sandybrown;
  font-weight: 800;
  font-size: 14px;
}
.row_key {
  font-weight: 800;
  font-size: 14px;
}
</style>
